'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/property-information/normalize.js
// module id = 17
// module chunks = 0